var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"nav-landing"},[_c('b-nav',{staticClass:"p-2",attrs:{"pills":"","align":"center"}},[_c('b-nav-item',{attrs:{"href":"#products"}},[_vm._v("Productos y Servicios")]),_c('b-nav-item',{attrs:{"href":"#rocket"}},[_vm._v("Experiencia")]),_c('b-nav-item',{attrs:{"href":"#methodology"}},[_vm._v("Metodología")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }